import React from 'react';
import GalaxyBackground from '../ui/GalaxyBackground';

/**
 * AppLayout Component
 * Provides consistent galaxy background across all application pages
 * Wraps page content with the GalaxyBackground for visual consistency
 */
export default function AppLayout({ children, className = '' }) {
  return (
    <div className="relative min-h-screen bg-[#050505] text-white overflow-x-hidden">
      {/* Galaxy Background */}
      <GalaxyBackground />
      
      {/* Content Wrapper */}
      <div className={`relative z-10 ${className}`}>
        {children}
      </div>
    </div>
  );
}
